const volcanes = {
  payingByMessage: 'Membayar melalui ',
  safePaymentPage: 'Halaman pembayaran aman',
  finishYourPaymentMessage: 'Selesaikan pembelian Anda, selesaikan pembayaran Anda di sini :)',
  inputCustomerName: 'Nama',
  inputCustomerEmail: 'Email',
  inputCustomerPhoneNumber: 'Nomor Telepon',
  inputCustumerPhoneNumberOptional: '(opsional)',
  emptyCardSecurityCode: 'Masukkan kode keamanan kartu',
  invalidSecurityCode: 'Kode keamanan tidak valid',
  invalidCvv: 'CVV tidak valid',
  fieldCardSecurityCode: 'Kode keamanan (CVV)',
  fieldCardHolderName: 'Nama lengkap (sesuai yang tertera di kartu)',
  fieldCardExpiryDate: 'Tanggal Kedaluwarsa',
  placeholderCardExpiryDate: 'BB/TTTT',
  fieldCardNumber: 'Nomor kartu',
  fieldOneClickCardNumber: '{brand} akhiran {lastFour}',
  transactionFeeTooltip: 'Biaya Pemrosesan',
  total: 'Total',
  amount: 'Jumlah',
  termsLabel: 'Dengan membayar, Anda menyetujui  ',
  termsReferenceLink: 'ketentuan layanan',
  termsEbanxLabel: ' dari EBANX.',
  paymentPageTitle: 'Halaman Pembayaran',
  selectPaymentMethod: 'Pilih metode pembayaran',
  fatalErrorTitle: 'Ups!',
  fatalErrorMessage: 'Maaf, kami tidak dapat menemukan detail pembayaran Anda.',
  fatalErrorFooter: 'Pembayaran aman didukung oleh',
  panamaUsdDisclaimer: 'Pembayaran diproses melalui EBANX. Karena perutean regional, laporan bank Anda mungkin merujuk Panama (PAB), yang mempertahankan paritas tetap 1:1 dengan USD. Tagihan akhir harus mencerminkan harga USD yang ditampilkan.',
  merchantPaymentCode: 'Pesanan #',
};

module.exports = volcanes;
